(function () {
  // ── Market check ──────────────────────────────────────────────────────────
  const EXEMPT_COUNTRIES = ['AU', 'GB', 'NZ'];
  const country = window.Shopify?.country || '';   // e.g. "AU", "GB", "NZ", "US"

  if (EXEMPT_COUNTRIES.includes(country.toUpperCase())) return;

  // ── Selectors (both product-card and PDP) ─────────────────────────────────
  const SELECTORS = [
  // Product card (hover)
  '.product-card-wrapper .card__content .card__information .hover_content .option_size .variant_normal label',
  // PDP
  '.product__info-container .slect_variant_size .product-form__input input[type=radio] + label',
  // Cart drawer
  '#CartDrawer .cart-item__details dl .product-option dd',
  // Cart page
  '.cart-item__details .cart_item_content dl .product-option dd',
];

  // ── Conversion: subtract 4 from any leading integer ──────────────────────
  function convertLabel(label) {
    // Walk text nodes directly inside the label (skips .visually-hidden span)
    label.childNodes.forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) return;

      const trimmed = node.textContent.trim();
      const num = parseInt(trimmed, 10);

      if (!isNaN(num)) {
        // Preserve surrounding whitespace, replace just the numeral
        node.textContent = node.textContent.replace(trimmed, 'US' + String(num - 4));
      }
    });
  }

  // ── Run on existing DOM ───────────────────────────────────────────────────
  function convertAll() {
    SELECTORS.forEach((sel) => {
      document.querySelectorAll(sel).forEach(convertLabel);
    });
  }

  // ── Also watch for dynamically injected labels (AJAX sections, etc.) ─────
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        SELECTORS.forEach((sel) => {
          // Check if the added node itself matches, or contains matches
          if (node.matches?.(sel)) convertLabel(node);
          node.querySelectorAll?.(sel).forEach(convertLabel);
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Run once immediately, and again after DOM is fully ready
  convertAll();
  document.addEventListener('DOMContentLoaded', convertAll);
})();